import React from "react";
import { ACTIONS } from "../state/contexts/quizState";
import { useQuiz } from "../services/hooks/useQuiz";

export default React.memo(function QuizQ5({ isActive }) {
  const { setAnswer, quizResponses } = useQuiz();

  const { skinConcerns } = quizResponses;

  const onAnswer = (answer) => {
    if (skinConcerns.indexOf(answer) !== -1) {
      removeSkinConcern(answer);
    } else {
      setSkinConcern(answer);
    }
  };

  const setSkinConcern = (answer) => {
    setAnswer(ACTIONS.SET_SKIN_CONCERN, {
      skinConcern: answer,
    });
  };

  const removeSkinConcern = (answer) => {
    setAnswer(ACTIONS.REMOVE_SKIN_CONCERN, {
      skinConcern: answer,
    });
  };

  const handleChange = (e) => {
    if (e.target.checked) {
      removeSkinConcern(e.target.value);
    } else {
      setSkinConcern(e.target.value);
    }
  };

  const options = [
    {
      title: "Acne",
      text: "You battle with acne on a regular basis",
    },
    {
      title: "Aging",
      text: "Your skin is showing wrinkles, loss of elasticity, laxity, and may be rough-textured.",
    },
    {
      title: "Breakouts",
      text: "You experience breakouts more frequently than others.",
    },
    {
      title: "Cellulite",
      text: "Your skin is uneven and you experience dimpling.",
    },
    {
      title: "Dark spots",
      text: "Your skin has visible dark spots or uneven skin tone.",
    },
    {
      title: "Enlarged pores",
      text: "Your skin shows visible topographic changes on its surfaces.",
    },
    {
      title: "Oiliness",
      text: "You have oily skin.",
    },
    {
      title: "Undereye circles",
      text: "You frequently have visible undereye circles/puffiness.",
    },
    {
      title: "Redness",
      text: "You have redness of skin not due to sunburn.",
    },
    {
      title: "Sensitivity",
      text: "You experience stinging, burning, pain, pruritus, tingling, sensations in response to stimuli that normally should not provoke such sensations.",
    },
    {
      title: "Stretch marks",
      text: "You have stretch marks on significant parts of your skin.",
    },
    {
      title: "Sun protection",
      text: "You struggle with sunburn.",
    },
  ];

  const listItems = options.map(({ title, text }) => (
    <div
      key={title}
      className="quiz-radio-option"
      onClick={() => {
        onAnswer(title);
      }}
    >
      <div className="custom-control custom-checkbox float-left">
        <input
          type="checkbox"
          id={title}
          name="skinConcerns"
          value={title}
          className="custom-control-input"
          checked={skinConcerns.indexOf(title) !== -1}
          onChange={handleChange}
        />
        <label className="custom-control-label" htmlFor={title}></label>
      </div>
      <div className="ml-8 quiz-radio-content">
        <div className="font-size-h6">{title}</div>
        <p>{text}</p>
      </div>
    </div>
  ));

  if (!isActive) {
    return null;
  }

  return (
    <>
      <h4 className="mb-8">What are your main skincare concerns?</h4>
      <p className="text-muted">Select all that apply</p>

      <div className="quiz-radio-options">{listItems}</div>
    </>
  );
});
